import React from 'react';
import BoardChats from './BoardChats';
import { BOARD_ID_SELECTORS } from '../SparkOutputBoard/helper/constants';

type Props = {
  chatID: string;
  boardID: string;
};

function BoardChatContainer({ chatID, boardID }: Props) {
  return (
    <BoardChats
      chatID={chatID}
      boardID={boardID}
      className={BOARD_ID_SELECTORS.BOARD_CHAT_CLASS}
    />
  );
}

export default BoardChatContainer;
